<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2 align-items-center">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">
              <i class="fas fa-tag mr-2 text-primary"></i>
              Promoción: <span class="text-muted">{{ promocion.codigo }}</span>
            </h1>
          </div>
          <div class="col-sm-6 text-right">
            <router-link to="/promociones" class="btn btn-outline-secondary mr-2">
              <i class="fas fa-arrow-left"></i> Volver
            </router-link>
            <router-link :to="'/promociones/editar/' + promocion.id" class="btn btn-warning shadow-sm">
              <i class="fas fa-edit"></i> Editar Promoción
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <div class="card card-outline card-primary shadow">
            <div class="card-header">
              <h3 class="card-title font-weight-bold">
                <i class="fas fa-info-circle mr-1"></i> Detalles Generales
              </h3>
              <div class="card-tools">
                <span :class="statusBadgeClass" class="badge p-2">
                  {{ (promocion.estado || '').toUpperCase() }}
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <table class="table table-sm table-hover mb-0">
                <tbody>
                  <tr>
                    <td class="font-weight-bold p-3">Descripción:</td>
                    <td class="p-3">{{ promocion.descripcion }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold p-3">Modo:</td>
                    <td class="p-3">
                      <span class="badge badge-info shadow-sm">
                        <i :class="promocion.modo === 'descuento' ? 'fas fa-percentage' : 'fas fa-gift'"></i>
                        {{ promocion.modo === 'descuento' ? 'DESCUENTO' : 'OBSEQUIO' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="promocion.modo === 'descuento'">
                    <td class="font-weight-bold p-3">Valor del beneficio:</td>
                    <td class="p-3 text-success font-weight-bold">
                      {{ promocion.tipo_valor === 'porcentaje' ? promocion.valor + '%' : '$ ' + promocion.valor }}
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="font-weight-bold p-3">Producto Obsequio:</td>
                    <td class="p-3 text-primary">
                      <i class="fas fa-box-open mr-1"></i>
                      {{ promocion.obsequio_producto ? promocion.obsequio_producto.codigo + ' - ' + promocion.obsequio_producto.descripcion : 'No asignado' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card shadow-sm border-left-info">
            <div class="card-body">
              <div class="row text-center">
                <div class="col-6 border-right">
                  <label class="text-muted small d-block">MONTO MÍNIMO</label>
                  <h5 class="font-weight-bold">{{ promocion.min_monto ? '$ ' + promocion.min_monto : 'Sin mínimo' }}</h5>
                </div>
                <div class="col-6">
                  <label class="text-muted small d-block">CANTIDAD MÍNIMA</label>
                  <h5 class="font-weight-bold">{{ promocion.min_cantidad ? promocion.min_cantidad + ' unid.' : 'Sin mínimo' }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="info-box bg-light border shadow-sm">
            <span class="info-box-icon bg-navy"><i class="far fa-calendar-alt"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">Vigencia de la promoción</span>
              <span class="info-box-number">
                {{ promocion.fecha_inicio }} <i class="fas fa-long-arrow-alt-right mx-2 text-muted"></i> 
                {{ promocion.fecha_fin || 'Indefinida' }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-7">
          <div class="card card-navy card-outline shadow-sm">
            <div class="card-header py-2">
              <h3 class="card-title"><i class="fas fa-users mr-1"></i> Clientes Beneficiados</h3>
            </div>
            <div class="card-body">
              <div class="alert alert-success border-0" v-if="promocion.all_clients">
                <i class="icon fas fa-check-circle"></i> 
                Esta promoción es <strong>Global</strong>. Aplica para todos los clientes registrados.
              </div>
              <table v-else id="clientesTable" class="table table-sm table-striped w-100"></table>
            </div>
          </div>

          <div class="card card-teal card-outline shadow-sm">
            <div class="card-header py-2">
              <h3 class="card-title"><i class="fas fa-boxes mr-1"></i> Productos que activan la promo</h3>
            </div>
            <div class="card-body">
              <div class="alert alert-info border-0" v-if="promocion.all_products">
                <i class="icon fas fa-info"></i> 
                Aplica para <strong>Todo el Inventario</strong> de Comercial Kurdamovil.
              </div>
              <table v-else id="productosTable" class="table table-sm table-striped w-100"></table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/services/api";
import $ from "jquery";
import "datatables.net-bs4";

export default {
  data() {
    return {
      promocion: {},
    };
  },
  computed: {
    statusBadgeClass() {
      const status = this.promocion.estado;
      return {
        'badge-success': status === 'activa',
        'badge-warning': status === 'pausada',
        'badge-danger': status === 'inactiva',
        'shadow-sm': true
      };
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    try {
      // Nota: El controlador devuelve 'obsequio_producto' por el with() de Laravel
      const { data } = await api.get(`/promociones/${id}`);
      this.promocion = data;
      
      this.$nextTick(() => {
        if (!this.promocion.all_clients) this.initTable("#clientesTable", data.clientes, ["codigo", "nombre"]);
        if (!this.promocion.all_products) this.initTable("#productosTable", data.productos, ["codigo", "descripcion"]);
      });
    } catch (error) {
      console.error("Error al cargar promoción:", error);
    }
  },
  methods: {
    initTable(selector, data, columns) {
      $(selector).DataTable({
        data: data || [],
        responsive: true,
        destroy: true,
        searching: true, // Habilitado para que el usuario encuentre rápido un producto en la lista
        paging: true,
        pageLength: 5,
        lengthChange: false,
        info: false,
        columns: columns.map(col => ({ 
          title: col.charAt(0).toUpperCase() + col.slice(1), 
          data: col 
        })),
        language: { url: "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json" },
      });
    }
  }
};
</script>

<style scoped>
.border-left-info { border-left: 4px solid #17a2b8; }
.card-title { font-size: 1.1rem; }
.info-box { min-height: 70px; }
.info-box-icon { width: 60px; font-size: 1.5rem; }
</style>